var t = /* @__PURE__ */ ((e) => (e.Fixed = "fixed", e.Flexible = "flexible", e))(t || {});
const i = Symbol(
  "setActiveTab"
), b = Symbol("variant");
export {
  t as VariantsEnum,
  i as setActiveTabKey,
  b as variantKey
};
